import { BRAND_META, CSS_TEXT_LOGOS, BRAND_BG, DEFAULT_BRAND_BG } from "./shopData";

export default function BrandCard({ brand, count, onClick }) {
  const meta = BRAND_META[brand] || {};
  const cssLogo = CSS_TEXT_LOGOS[brand];
  const bg = BRAND_BG[brand] || DEFAULT_BRAND_BG;

  return (
    <div
      data-testid={`brand-card-${brand.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      onClick={onClick}
      className="group relative rounded-xl overflow-hidden cursor-pointer border border-[#1E1E1E] hover:border-[#FF3B30]/40 transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,59,48,0.06)] h-[100px]"
      style={{ background: bg }}
    >
      <div className="absolute inset-0 flex items-center justify-between px-5">
        <div className="flex-1 min-w-0">
          <h3 className="text-white font-bold text-base group-hover:text-[#FF3B30] transition-colors truncate">{brand}</h3>
          {meta.tagline && <p className="text-[#666] text-[10px] mt-0.5 truncate">{meta.tagline}</p>}
          <p className="text-[#555] text-[10px] mt-1">{count.toLocaleString("nl-NL")} producten</p>
        </div>
        <div className="flex-shrink-0 ml-3">
          <span className="font-['Orbitron'] font-bold text-lg opacity-60 group-hover:opacity-80 transition-opacity whitespace-nowrap text-white">
            {cssLogo?.text || (brand.length <= 12 ? brand.toUpperCase() : brand.split(" ")[0].toUpperCase())}
          </span>
        </div>
      </div>
    </div>
  );
}
